import React, { useState, useEffect, useRef } from 'react';
import { useRequest, useParams, Helmet } from 'umi';
import { BatchInfoVO } from '@/types/camp/campIndex/indexTypes';
import { StatisticDataVO } from '@/types/camp/admin/statisticDataType';
import { getStatisticData } from '@/utils/requests/camp/requests_admin';
import EchartsFunnelNodes from './statisticData/echartsFunnelNodes';
import EchartsBarVideo from './statisticData/echartsBarVideo';
import EchartsBarDynamic from './statisticData/echartsBarDynamic';
import StudyRanking from './statisticData/studyRanking';
import TopCard from './statisticData/topCard';
import { Spin } from 'antd';

interface Props {
  batchInfo: BatchInfoVO;
}
const StatisticData: React.FC<Props> = ({ batchInfo }) => {
  const [data, setData] = useState<StatisticDataVO>();
  const elementRef = useRef<HTMLDivElement | null>(null);
  const [leftHeight, setLeftHeight] = useState(0);
  const [isData, setIsData] = useState(false);

  useEffect(() => {
    let timerId = setTimeout(function () {
      if (elementRef.current) {
        setLeftHeight(elementRef.current.offsetHeight);
      }
    }, 500);
    return () => {
      clearTimeout(timerId);
    };
  }, [isData]);

  const { run: getStatisticDataRequest } = useRequest(
    () => {
      return getStatisticData(batchInfo.id);
    },
    {
      manual: true,
      onSuccess: (res) => {
        setData(res);
        setIsData(true);
      },
    },
  );

  useEffect(() => {
    getStatisticDataRequest();
  }, []);

  return (
    <>
      <div>
        <TopCard data={data} />
      </div>
      <div className="flex_3" style={{ marginBottom: 24 }}>
        <div style={{ minHeight: 660, width: 792, marginRight: 24 }} ref={elementRef}>
          <EchartsFunnelNodes data={data} />
        </div>
        <div style={{ minHeight: 660, width: 384, flex: 1 }}>
          {leftHeight > 0 ? (
            <StudyRanking studentBaseInfo={batchInfo} leftHeight={leftHeight - 80} />
          ) : (
            <div className="com_cmap_card_box" style={{ minHeight: 660, textAlign: 'center' }}>
              <Spin style={{ marginTop: 48 }} />
            </div>
          )}
        </div>
      </div>

      <div className="flex_3" style={{ minHeight: 440, marginBottom: 24 }}>
        <div style={{ width: 588 }}>
          <EchartsBarVideo data={data} />
        </div>
        <div style={{ width: 588 }}>
          <EchartsBarDynamic data={data} />
        </div>
      </div>
    </>
  );
};
export default StatisticData;
